var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProtectiveClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.82,12.29H34.5V9.13H29.82ZM28.36,25.42V5.31l-1.19.11v20ZM41.25,56c-2.48,0-4.83,0-7.17,0-.72,0-.77-.5-.87-1-.73-3.7-1.47-7.65-2.22-11.35q-1.39-7-2.82-14.07a9.15,9.15,0,0,0-.34-1L22,56H14.16c.25-1.35.48-2.65.74-3.94l4.86-24.31c.36-1.77.8-3.53,1-5.32A7.51,7.51,0,0,0,20.43,20c-.63-2.9-1.29-5.8-1.93-8.7l-.29-.06L12.74,23.56,8,22.32c.46-1.25.87-2.42,1.31-3.58q3-7.95,6-15.9C16.17.55,17,0,19.43,0h3.86c1.21,3.45,2.49,4.6,4.88,4.46C30,4.35,31,3.15,31.68.24A51.06,51.06,0,0,1,37.61.3c1.5.17,2.22,1.52,2.73,2.87,1.58,4.2,3.18,8.4,4.76,12.6L47.46,22l-4.39,1.34L36.88,10.63A53.92,53.92,0,0,1,35.51,17c-1.58,4.54-.17,8.85.69,13.22,1.63,8.31,3.31,16.62,5,24.93,0,.17,0,.33.08.61Z",
    fill: "#0A0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectiveClothing);
export default __webpack_public_path__ + "static/media/protective-clothing.f8bdd0eb.svg";
export { ForwardRef as ReactComponent };